import { NestedTreeControl } from '@angular/cdk/tree'
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSnackBar } from '@angular/material/snack-bar'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import * as moment from 'moment'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../../notification/shared/notification.service'
import { CommandeSettingsCoeff, CommandeSettingsDeliveries } from '../../settings/commande-param/commande-param-settings/shared/commande-param-settings'
import { CommandeParamSettingsService } from '../../settings/commande-param/commande-param-settings/shared/commande-param-settings.service'
import { Client } from '../../shared/client/client'
import { ClientService } from '../../shared/client/client.service'
import { CommandeDetails, CommandeList, ListLigneCommande } from '../shared/commande'
import { CommandeEditSendDialogComponent } from '../shared/commande-edit-send-dialog/commande-edit-send-dialog.component'
import { CommandeService } from '../shared/commande.service'
import { Inventaire, Lingerie } from '../shared/inventaire'
import { CommandeStatutHelpComponent } from './commande-statut-help/commande-statut-help.component'

interface CommandeNode {
  id?: string
  date_livraison?: string
  date_transmission?: string
  numCommande?: string
  statut?: any
  emetteur?: any
  lingerie?: Lingerie
  date_modification?: string
  children?: CommandeNode[]
  can_edit_send?: boolean
}

@Component({
  selector: 'app-commande-list',
  templateUrl: './commande-list.component.html',
  styleUrls: ['./commande-list.component.scss']
})
export class CommandeListComponent implements OnInit, OnDestroy {

  public commandeSettingsDeliveries: CommandeSettingsDeliveries[]
  public coefficient: CommandeSettingsCoeff
  treeControl = new NestedTreeControl<CommandeNode>(node => node.children)
  ELEMENT_DATA: MatTableDataSource<CommandeNode> = new MatTableDataSource<CommandeNode>()
  columns = [
    { id: 'date_livraison', libelle: 'Date de livraison' },
    { id: 'statut', libelle: 'Statut' },
  ]
  displayedColumns: Array<string> = ['date_livraison', 'statut', 'actions']
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  loading: boolean = false
  commandeDetails: CommandeDetails
  inventaireDetails: Inventaire
  currentClient: Client
  isSideBarOpen: boolean = false
  sideBarData: ListLigneCommande[]
  isSideBarInventaireOpen: boolean = false
  sideBarInventaireData: Inventaire
  isSelected: boolean = true
  dateLivraison: string
  isSending: string = null
  inventaires = []
  isComptageLingerie: boolean = false
  hasInventaires: boolean = false
  enabledCoeff: boolean = false
  subClient: Subscription
  popup

  constructor(
    private commandeService: CommandeService,
    private clientService: ClientService,
    private snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private commandeSettingsService: CommandeParamSettingsService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    moment.locale('fr')

    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.isSelected = true
      this.currentClient = client
      if (!this.currentClient.is_livraison_commande) {
        this.router.navigate(['/escli/linge-hebergement/list-besoin'])
      } else {
        if (this.currentClient.is_comptage_lingerie) {
          this.isComptageLingerie = true
        } else {
          this.isComptageLingerie = false
        }

        this.getCommandeList(this.currentClient)
        this.getClientDeliveries(this.currentClient)
        this.getClientCoefficient(this.currentClient)
      }
    })

    this.paginator.page.subscribe(event => {
      this.getCommandeList(this.currentClient, event.pageIndex, event.pageSize, this.isSelected);
    });
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  getCommandeList(client: Client, page = 0, pageSize = this.paginator?.pageSize || 10, future = true) {
    this.loading = true
    this.commandeService.getCommandeList(client.id, page + 1, pageSize, !future).subscribe(result => {
      let commandes = result['orders'];
      commandes.forEach(commande => {
        if (commande.inventaires.length > 0) {
          commande['children'] = commande.inventaires.sort((a, b) => a.lingerie.libelle > b.lingerie.libelle ? 1 : -1)
        }
      })

      this.ELEMENT_DATA.data = commandes as CommandeNode[]
      this.paginator._intl.itemsPerPageLabel = 'Livraisons par page '
      this.paginator.length = result['count']
      this.loading = false
    })
  }

  getCommandeDetails(node) {
    this.loading = true
    if (node.children) {
      this.hasInventaires = true
    } else {
      this.hasInventaires = false
    }
    this.commandeService.getCommandeDetails(node.id).subscribe(data => {
      this.commandeDetails = data
      this.dateLivraison = data.date_livraison
      this.loading = false
      this.openSideBar(this.commandeDetails.lod_ligne_commandes)
    })
  }

  getInventaireDetails(inventaire: Inventaire) {
    if (!this.disabledVoir(inventaire)) {
      this.loading = true
      this.inventaireDetails = inventaire
      let commande = this.ELEMENT_DATA.data.find(el => el.children?.find(child => child.id == inventaire.id))

      this.commandeService.getInventaire(inventaire.id).subscribe(data => {
        this.inventaireDetails.inventaire_lignes = data.inventaire_lignes.filter(el => el.restant != null)

        this.dateLivraison = commande.date_livraison
        this.enabledCoeff = inventaire.enabled_coeff
        this.loading = false
        this.openSideBarInventaire(this.inventaireDetails)
      })
    }
  }

  private openSideBar(commandeDetails: ListLigneCommande[]) {
    this.sideBarData = commandeDetails
    window.scrollTo(0, 0)
    this.isSideBarOpen = true
    document.body.style.overflow = "hidden"
  }

  private openSideBarInventaire(inventaireDetails: Inventaire) {
    this.sideBarInventaireData = inventaireDetails
    window.scrollTo(0, 0)
    this.isSideBarInventaireOpen = true
    document.body.style.overflow = "hidden"
  }

  onSidebarClose() {
    this.isSideBarOpen = false
    document.body.style.overflow = "auto"
  }

  onSidebarInventaireClose() {
    this.isSideBarInventaireOpen = false
    document.body.style.overflow = "auto"
  }

  sendCommande(id) {
    this.isSending = id
    this.commandeService.sendCommande(id, this.currentClient).subscribe(async data => {
      this.ngOnInit()
      let list = data as Array<string>
      if (list.length > 0) {
        if (list.length == 1) {
          this.notificationService.notif("L'article " + list[0] + " n'est plus dans votre contrat, il est retiré de la commande", "warn", 5000)
        } else {
          this.notificationService.notif("Les articles " + list + " ne sont plus dans votre contrat, ils sont retirés de la commande", "warn", 5000)
        }
        const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
        await sleep(5000)
      }
      this.notificationService.notif("Commande transmise", "notif");
      this.isSending = null
    }, error => this.isSending = null)
  }

  reloadData(state: string) {
    this.loading = true
    if (state === 'future') {
      this.isSelected = true
      this.getCommandeList(this.currentClient, 0, this.paginator.pageSize, this.isSelected);
      this.displayedColumns = ['date_livraison', 'statut', 'actions']
    } else if (state === 'past') {
      this.isSelected = false
      this.getCommandeList(this.currentClient, 0, this.paginator.pageSize, this.isSelected);
      this.displayedColumns = ['date_livraison', 'statut', 'actions']
    }
    this.loading = false
  }

  isDispatchable(commande: CommandeList) {
    if (this.isSending == commande.id) {
      return false
    }
    if (this.isSelected) {
      return commande.statut.libelle === 'A transmettre' ||
        commande.statut.libelle === 'A transmettre avant 12h' &&
        moment(commande.date_livraison).format() > moment(new Date()).format()
    }
    return false
  }

  isEditable(commande: CommandeList | CommandeNode) {
    if (this.isSelected) {
      return commande.statut.code !== 'T' &&
        commande.statut.code !== 'T0' &&
        commande.statut.code !== 'DD' &&
        commande.statut.code !== 'V'
    }
    return false
  }

  isEditableInventaire(inventaire: CommandeList) {
    if (this.isSelected) {
      let commande = this.ELEMENT_DATA.data.find(el => el.children?.find(child => child.id == inventaire.id))
      return inventaire.statut.code !== 'V' && this.isEditable(commande)
    }
    return false
  }

  isPrintable(commande: CommandeList) {
    return commande.statut.code === 'T' ||
      commande.statut.code === 'T0'
  }

  export(id) {
    this.commandeService.export(id, this.currentClient.id).subscribe()
  }

  delivered() {
    return new Date() >= new Date(this.dateLivraison)
  }

  getInventaires(commande) {
    let index = this.inventaires.findIndex(value => value.commande.id === commande.id)
    if (index != -1) {
      return this.inventaires[index].inventaires
    }
    return []
  }

  hasChildren = (index: number, node: CommandeNode) => {
    return node.children && node.children.length > 0
  }

  isCommande = (index: number, node: CommandeNode) => {
    return node.date_livraison != null
  }

  getDotation(articleId, dotations, date_livraison): number {
    let coeff = this.currentClient.enabled_coeff ? this.coefficient?.coeff_max_commande : 1
    let dotations_jour
    if (this.currentClient.is_comptage_jour) {
      dotations_jour = dotations.filter(ligne => ligne.jour_livraison == date_livraison.day())
    } else {
      dotations_jour = dotations.filter(ligne => ligne.jour_livraison == 0)
    }
    if (dotations_jour.length > 0) {
      let dotation = dotations_jour[0].dotations.filter(value => value.article.id == articleId)
      if (dotation.length > 0) {
        return Math.ceil(+(this.getDayMultiplier(date_livraison) * dotation[0].quantite * coeff))
      }
    }
    return 0
  }

  getDayMultiplier(date_livraison) {
    let curDayMultiplier = this.commandeSettingsDeliveries.filter(coef => coef.jrs_relivraison_lp === moment(date_livraison).day())
    if (!('multiple_mab_jour' in curDayMultiplier[0]) || curDayMultiplier[0].multiple_mab_jour === 0) {
      return 1
    } else {
      return curDayMultiplier[0].multiple_mab_jour
    }
  }

  getClientDeliveries(client) {
    this.commandeSettingsService.getCommandDeliveries(client.id).subscribe(
      (data) => {
        this.commandeSettingsDeliveries = data
      }
    )
  }

  getClientCoefficient(client) {
    this.commandeSettingsService.getCommandMaxOrderRatio(client.id).subscribe(
      (data) => {
        this.coefficient = data
      })
  }

  help() {
    this.dialog.open(CommandeStatutHelpComponent, { data: this.currentClient.is_comptage_lingerie })
  }

  disabledVoir(node) {
    return node.statut.code == 'AS' || node.statut.code == 'NS'
  }

  editSendOrder(commande) {
    this.dialog.open(CommandeEditSendDialogComponent, {
      data: { commande: commande }
    })
  }
}